function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import get from 'lodash/get';
import isObject from "./isObject";
import isNil from 'lodash/isNil';
/** Merges the `defaults` object of type `T` into the `formData` of type `T`
 *
 * When merging defaults and form data, we want to merge in this specific way:
 * - objects are deeply merged
 * - arrays are merged in such a way that:
 *   - when the array is set in form data, only array entries set in form data
 *     are deeply merged; additional entries from the defaults are ignored unless `mergeExtraArrayDefaults` is true, in
 *     which case the extras are appended onto the end of the form data
 *   - when the array is not set in form data, the default is copied over
 * - scalars are overwritten/set by form data unless undefined and there is a default AND `defaultSupercedesUndefined`
 *   is true
 *
 * @param [defaults] - The defaults to merge
 * @param [formData] - The form data into which the defaults will be merged
 * @param [mergeExtraArrayDefaults=false] - If true, any additional default array entries are appended onto the formData
 * @param [defaultSupercedesUndefined=false] - If true, an explicit undefined value will be overwritten by the default value
 * @param [overrideFormDataWithDefaults=false] - If true, the default value will overwrite the form data value. If the value
 *        doesn't exist in the default, we take it from formData and in the case where the value is set to undefined in formData.
 *       This is useful when we have already merged formData with defaults and want to add an additional field from formData
 *       that does not exist in defaults.
 * @returns - The resulting merged form data with defaults
 */

export default function mergeDefaultsWithFormData(defaults, formData) {
  var mergeExtraArrayDefaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var defaultSupercedesUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var overrideFormDataWithDefaults = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (Array.isArray(formData)) {
    var defaultsArray = Array.isArray(defaults) ? defaults : []; // If overrideFormDataWithDefaults is true, we want to override the formData with the defaults

    var overrideArray = overrideFormDataWithDefaults ? defaultsArray : formData;
    var overrideOppositeArray = overrideFormDataWithDefaults ? formData : defaultsArray;
    var mapped = overrideArray.map(function (value, idx) {
      if (overrideOppositeArray[idx]) {
        return mergeDefaultsWithFormData(defaultsArray[idx], formData[idx], mergeExtraArrayDefaults, defaultSupercedesUndefined, overrideFormDataWithDefaults);
      }

      return value;
    }); // Merge any extra defaults when mergeExtraArrayDefaults is true
    // Or when overrideFormDataWithDefaults is true and the default array is shorter than the formData array

    if ((mergeExtraArrayDefaults || overrideFormDataWithDefaults) && mapped.length < overrideOppositeArray.length) {
      mapped.push.apply(mapped, _toConsumableArray(overrideOppositeArray.slice(mapped.length)));
    }

    return mapped;
  }

  if (isObject(formData)) {
    var acc = Object.assign({}, defaults); // Prevent mutation of source object.

    return Object.keys(formData).reduce(function (acc, key) {
      var keyValue = get(formData, key);
      var keyExistsInDefaults = isObject(defaults) && key in defaults;
      var keyExistsInFormData = (key in formData);
      acc[key] = mergeDefaultsWithFormData(defaults ? get(defaults, key) : {}, keyValue, mergeExtraArrayDefaults, defaultSupercedesUndefined, // overrideFormDataWithDefaults can be true only when the key value exists in defaults
      // Or if the key value doesn't exist in formData
      overrideFormDataWithDefaults && (keyExistsInDefaults || !keyExistsInFormData));
      return acc;
    }, acc);
  }
  /**
   * If the defaultSupercedesUndefined flag is true
   *    And formData is set to undefined or null and defaults are defined
   *    Or if formData is a number and is NaN return defaults
   * Or if overrideFormDataWithDefaults flag is true and formData is set to not undefined/null return defaults
   */


  if (defaultSupercedesUndefined && (!isNil(defaults) && isNil(formData) || typeof formData === 'number' && isNaN(formData)) || overrideFormDataWithDefaults && !isNil(formData)) {
    return defaults;
  }

  return formData;
}